module.exports = __webpack_public_path__ + "static/media/avatar_5.f9d1f33f.svg";